'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cross = require('./Cross');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cross).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Cross/index.js
// module id = 1167
// module chunks = 1